var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRedAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 4.7998C5.6399 4.7998 5.3999 5.0398 5.3999 5.3998V8.3998C5.3999 8.7598 5.6399 8.9998 5.9999 8.9998C6.3599 8.9998 6.5999 8.7598 6.5999 8.3998V5.3998C6.5999 5.0398 6.3599 4.7998 5.9999 4.7998Z",
    fill: "#E83647"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 4.2C6.33127 4.2 6.5999 3.93137 6.5999 3.6C6.5999 3.26863 6.33127 3 5.9999 3C5.66853 3 5.3999 3.26863 5.3999 3.6C5.3999 3.93137 5.66853 4.2 5.9999 4.2Z",
    fill: "#E83647"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0ZM6 10.8C3.36 10.8 1.2 8.64 1.2 6C1.2 3.36 3.36 1.2 6 1.2C8.64 1.2 10.8 3.36 10.8 6C10.8 8.64 8.64 10.8 6 10.8Z",
    fill: "#E83647"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedAlert);
export default __webpack_public_path__ + "static/media/icon-red-alert.3a8a4797e24a35d95cb8472989a363ec.svg";
export { ForwardRef as ReactComponent };